import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import colors from '@app/constants/colors';

class Modal extends React.Component {
  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown, false);
  }

  handleKeyDown = ({ keyCode }) => {
    const { onHide } = this.props;
    if (keyCode === 27) onHide();
  };

  render() {
    const { show, onHide, children } = this.props;

    return (
      show ? (
        <GlobalWrapper>
          <ModalWindow>
            <CloseButton onClick={onHide} />
            {children}
          </ModalWindow>
        </GlobalWrapper>
      ) : (false)
    );
  }
}

Modal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.objectOf(PropTypes.element),
  ]),
  onHide: PropTypes.func, // outside hide action
  show: PropTypes.bool, // is modal visible
};

Modal.defaultProps = {
  onHide: () => {},
  children: null,
  show: true,
};

export default Modal;

const GlobalWrapper = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
`;

const ModalWindow = styled.div`
  position: relative;
  background-color: ${colors.ALICE_BLUE};
  color: ${colors.FLAMENKO};
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 100%;
  max-width: 850px;
  height: auto;
  min-height: 150px;
  max-height: 90%;
  padding: 30px;
  border-radius: 30px;
  animation: animateShow 0.3s ease;
`;

const CloseButton = styled.button`
  position: absolute;
  top: -15px;
  right: -15px;
  outline: none;
  border: none;
  padding: 0;
  margin: 0;
  background-color: ${colors.FLAMENKO};
  color: ${colors.ALICE_BLUE};
  width: 40px;
  height: 40px;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.3s ease;
  
  &:after {
    position: absolute;
    content: '\\00D7';
    margin: 0;
    padding: 0;
    font-size: 50px;
    line-height: 40px;
    top: -5px;
    right: 7px;
  }
  
  &:hover {
    background-color: ${colors.ALIZARIN_CRIMSON};
    transition: all 0.3s ease;
  }
`;
